__turbopack_context__.v({
  "expertiseBorder": "_66zjiG_expertiseBorder",
  "expertiseTitle": "_66zjiG_expertiseTitle",
});
